'use strict';

import { bind, forEach, isElement } from "lodash";

const
    selectors = {
        base: ".js-iframe"
    };

function resize(event) {
    let h = event.currentTarget.contentWindow.document.documentElement.scrollHeight + 'px';
    event.currentTarget.style.height = h;
}

export default class IFrame {
    constructor(element) {
        if (!isElement(element)) {
            return;
        }

        element.addEventListener('load', bind(resize, this));
    }
}

forEach(document.querySelectorAll(selectors.base), component => {
    new IFrame(component);
});